import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { DoctorService } from '../../../services/index';
import { DoctorModel } from '../../../model/index';

@Component({
    selector: 'add-edit-doctor-window',
    templateUrl: './addEditDoctor.component.html'
})
export class AddEditDoctorComponent implements OnInit {
    title: string;
    public mode: string;
    public list: any[] = [];
    @Input() from_page;
    @Input() doctordata: DoctorModel[] = [];
    @Output() doctorLoadEvent = new EventEmitter();
    isLoading: boolean = false;
    statusCtrl: FormControl;
    smsList = [];
    statusList = ['Active','Inactive'];

    constructor(private doctorService: DoctorService, public snackBar: MdSnackBar,
     public bsModalRef: BsModalRef, public toasterService: ToasterService)
    {
        this.statusCtrl = new FormControl('', [
            Validators.required
        ]);
    }

    ngOnInit(): void {
        this.smsList = ['YES', 'NO'];

        setTimeout(() => {
            $('#doctor_name').focus();
        }, 1000);
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onSaveDoctor(): void {
        let that = this;
        this.isLoading = true;
        this.doctorService
            .addEditUpdateDoctor(this.doctordata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.doctorLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/doctor/addEditDoctor.component.ts